import useSWR, { SWRConfiguration } from 'swr';
import type { PolicyProposalWithDetails } from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';
import { useMyOrganization } from '@/hooks/organization/use-my-organization';
import { SIGNABLE_POLL_INTERVAL_MS } from '@/components/execution/execution-polling';

const fetcher = async (url: string) =>
  await denApi.get<PolicyProposalWithDetails | null, void>(url);

export function useGetPolicyProposal(options?: SWRConfiguration) {
  const { organization } = useMyOrganization();
  const isAdmin = Boolean(organization?.isAdmin);
  // Org context comes from x-current-org-id cookie (not URL params)
  const url = isAdmin ? `admin/policy/proposals` : null;

  const { data, error, isLoading, mutate } =
    useSWR<PolicyProposalWithDetails | null>(url, fetcher, {
      refreshInterval: SIGNABLE_POLL_INTERVAL_MS,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      ...(options ?? {}),
    });

  return {
    proposal: data,
    isLoading,
    isError: error,
    mutate,
  };
}
